import { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { AutoCompleteExtraProps, DateRangeFormFieldProps, FormHandles } from "models/propTypes/genericFormProps";
import { ExportSieCreateFormProps } from "models/propTypes/documentPropTypes";
import { FormEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { DocumentFormTypes } from "models/formTypes";
//#endregion
//#region components
import { GenericForm } from "components/common";
import cssExports from "theme/styles/main.module.scss";
//#endregion

const ExportSIEForm: ForwardRefRenderFunction<FormHandles, ExportSieCreateFormProps> = (props, ref) => {
  const { financialYears } = props;

  return (
    <GenericForm<DocumentFormTypes.ExportSIE>
      formRef={ref}
      {...props}
      fields={[
        {
          type: FormEnums.FormSectionType.FIELDGROUPSECTION,
          label: TranslationKeys.Document.ExportSIEFileHelpText,
          className: cssExports.noBorder,
          innerFields: {
            financialYear: {
              label: TranslationKeys.Accounting.FinancialYear,
              type: FormEnums.FormFieldType.AUTOCOMPLETE,
              extraProps: {
                referenceFieldName: "financialYearId",
                items: financialYears,
              } as AutoCompleteExtraProps<DocumentFormTypes.ExportSIE>,
              disabled: (values: DocumentFormTypes.ExportSIE) =>
                values.dateRange?.start !== undefined || values.dateRange?.end !== undefined,
            },

            dateRange: {
              label: TranslationKeys.Common.Date,
              type: FormEnums.FormFieldType.DATERANGE,
              disabled: (values: DocumentFormTypes.ExportSIE) => values.financialYear !== undefined,
              extraProps: { restrictCrossDateSelection: true } as DateRangeFormFieldProps<DocumentFormTypes.ExportSIE>,
            },
          },
        },
      ]}
      hideSuccess
    />
  );
};

export default forwardRef(ExportSIEForm);
